module.exports = __webpack_public_path__ + "static/action-blueprints-mobile.dabe141f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homepage/action-blueprints-mobile.png
// module id = 2542
// module chunks = 35783957827783